import { createSlice } from "@reduxjs/toolkit";
import { getFeaturesByUser } from '../../controller/features/featuresController'

const featureSlice = createSlice({
    name: "features",
    initialState: {
        features: [],
        isFetching: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFeaturesByUser.pending, (state) => {
                state.isFetching = true;
                state.error = null;
            })
            .addCase(getFeaturesByUser.fulfilled, (state, action) => {
                state.isFetching = false;
                state.features = action.payload;
            })
            .addCase(getFeaturesByUser.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.payload;
            });
    },
});
export default featureSlice.reducer;